// extracted by mini-css-extract-plugin
export default {"card":"pna-z","carousel":"qna-z"};